import * as React from "react"
import { Typography } from "@mui/material"


export default function referenceColumn() {
	return [{
		name: 'reference', label: 'Reference',
		options: {
			display: 'excluded',
			filterType: 'textField'
		}
	}, {
		name: 'reference', label: 'Reference',
		options: {
			filter: false,
			customBodyRowRender: value => <Typography sx={{ textAlign: 'center' }}>{value}</Typography>
		}
	}]
}